import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "bg-color-header" }, null, -1)
const _hoisted_2 = { class: "w-full flex justify-content-start align-content-center max-content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "title-site" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "sub-titulo flex" }, "Programa"),
  /*#__PURE__*/_createElementVNode("div", { class: "titulo flex" }, "UNIVERSITÁRIO POR UM DIA")
], -1)
const _hoisted_4 = { class: "flex justify-content-center box-menu" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "p-menuitem-text" }
const _hoisted_7 = { class: "flex justify-content-center box-breadcrumb" }
const _hoisted_8 = { class: "flex justify-content-center" }
const _hoisted_9 = { class: "max-content w-full" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("footer", { class: "w-full flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", null, "IFSC - Instituto de Física de São Carlos - USP"),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createElementVNode("b", null, "Vem Saber")
    ])
  ])
], -1)
const _hoisted_11 = {
  key: 0,
  class: "loading"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "loader" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Image = _resolveComponent("Image")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Menubar = _resolveComponent("Menubar")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", {
      class: "bg-header header w-full flex justify-content-center",
      style: _normalizeStyle(_ctx.image)
    }, [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Image, {
          class: "logo-vem-saber",
          src: "/img/logo-m-300.png",
          alt: "Image Text"
        }),
        _hoisted_3
      ])
    ], 4),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Menubar, {
        class: "max-content w-full",
        model: _ctx.items
      }, {
        item: _withCtx(({ item }) => [
          _createVNode(_component_router_link, {
            to: item.to || '#',
            custom: ""
          }, {
            default: _withCtx(({ href, isActive, isExactActive }) => [
              _createElementVNode("a", {
                href: `${href}`,
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigate && _ctx.navigate(...args))),
                class: _normalizeClass(["p-menuitem-link router-link-active router-link-active-exact", {
              'active-link': isActive,
              'active-link-exact': isExactActive,
            }])
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["p-menuitem-icon", item.icon])
                }, null, 2),
                _createElementVNode("span", _hoisted_6, _toDisplayString(item.label), 1)
              ], 10, _hoisted_5)
            ]),
            _: 2
          }, 1032, ["to"])
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_Breadcrumb, {
        class: "max-content w-full",
        home: _ctx.home,
        model: _ctx.lista
      }, null, 8, ["home", "model"])
    ]),
    _createElementVNode("main", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_router_view)
      ])
    ]),
    _hoisted_10,
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
      : _createCommentVNode("", true)
  ], 64))
}